export const TIMEOUT_ANIMATION_BUTTON = 500;
export const BUTTON_UPDATE_TITLE = "Обновить стоимость в USD";